/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import moment from 'moment';
import Loader from 'components/atoms/loader';
import BiddingListConcurrents from 'components/atoms/bidding_list_concurrents';

// Dados do concorrente (cadastro, sócios, CNAEs, itens vencidos e sanções).
// Lê o market store: quem abre dispara getCompanyData e getProviderBiddings.
interface CompanyDetailsProps {
  setCurrentPageBidding: React.Dispatch<React.SetStateAction<number>>;
  currentPageBidding: number;
}

const CompanyDetails = (props: CompanyDetailsProps) => {
  const { setCurrentPageBidding, currentPageBidding } = props;

  const { company, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const address = [company?.logradouro, company?.numero, company?.bairro]
    .filter((part) => !!part)
    .join(', ');

  const formatDate = (date?: string) => (date ? moment(date).format('DD/MM/YYYY') : '-');

  return (
    <>
      {request?.get_company?.loading ? (
        <Loader />
      ) : request?.get_company?.error ? (
        <div className="px-3 mt-4">
          <div className="alert alert-secondary text-center m-0" role="alert">
            <h5 className="alert-heading">Dados cadastrais indisponíveis.</h5>
            <p className="mb-0">
              Não foi possível consultar os dados deste concorrente no momento. Tente novamente em
              alguns instantes.
            </p>
          </div>
        </div>
      ) : (
        <div>
          <div className="px-3">
            <div className="row mt-4">
              <div className="col-md-8">
                <span className="font-weight-bold">Nome</span>
                <p>{company?.razao_social}</p>
              </div>
              <div className="col-md-4">
                <span className="font-weight-bold">CNPJ</span>
                <p>
                  <a href={`/concorrente/${company?.cnpj}`} target="_blank" rel="noreferrer">
                    {company?.cnpj?.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      '$1.$2.$3/$4-$5',
                    )}
                  </a>
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="px-3">
            <div className="row">
              <div className="col-md-5">
                <span className="font-weight-bold">Endereço</span>
                <p>{address}</p>
              </div>
              <div className="col-md-4">
                <span className="font-weight-bold">Cidade</span>
                <p>{company?.municipio}</p>
              </div>
              <div className="col-md-3">
                <span className="font-weight-bold">Estado</span>
                <p>{company?.uf}</p>
              </div>
            </div>
          </div>
          <div className="px-3">
            <div className="row">
              <div className="col-md-5">
                <span className="font-weight-bold">Telefone</span>
                <p>{company?.telefone}</p>
              </div>
              <div className="col-md-4">
                <span className="font-weight-bold">E-mail</span>
                <p>{company?.email}</p>
              </div>
              <div className="col-md-3">
                <span className="font-weight-bold">Situação</span>
                <p>{company?.situacao}</p>
              </div>
            </div>
          </div>
          <hr />
          <div className="px-3">
            <div className="row">
              <div className="col-md-5">
                <span className="font-weight-bold">Tipo</span>
                <p>{company?.tipo_empresa}</p>
              </div>
              <div className="col-md-4">
                <span className="font-weight-bold">Natureza</span>
                <p>{company?.natureza_juridica}</p>
              </div>
              <div className="col-md-3">
                <span className="font-weight-bold">Abertura</span>
                <p>{company?.abertura ? formatDate(company.abertura) : ''}</p>
              </div>
            </div>
          </div>
          <hr />
          <div className="px-3">
            <div className="row">
              <div className="col-md-8">
                <span className="font-weight-bold">Sócios</span>
                <p>
                  {company?.quadro_socios_administradores?.map((socio) => (
                    <p key={socio.id} className="m-0">
                      {socio.nome} - {socio.descricao_vinculo}
                    </p>
                  ))}
                </p>
              </div>
              <div className="col-md-4">
                <span className="font-weight-bold">Capital Social</span>
                <p>
                  {company?.capital_social?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="px-3">
            <div className="row">
              <div className="col-md-12">
                <span className="font-weight-bold">Segmentos</span>
                <p>
                  {company?.cnaes?.map((cnae, i) => (
                    <p key={cnae.id} className={i === 0 ? 'font-weight-bold m-0' : 'm-0'}>
                      {cnae.codigo} - {cnae.descricao}
                    </p>
                  ))}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="px-3">
            <h5 className="font-weight-bold mb-3">Histórico de itens vencidos</h5>
            <BiddingListConcurrents
              setCurrentPageBidding={setCurrentPageBidding}
              currentPageBidding={currentPageBidding}
            />
          </div>
        </div>
      )}
      <hr />
      <div className="px-3">
        <h5 className="font-weight-bold">Sanções</h5>
        <ul className="table-responsive mt-3" style={{ maxHeight: '400px' }}>
          {request?.get_company?.loading ? (
            <Loader />
          ) : (
            <table className="table table-bordered">
              <thead style={{ backgroundColor: '#EBECEF' }}>
                <tr>
                  <th scope="col">Sanção</th>
                  <th scope="col">Órgão Sancionador</th>
                  <th scope="col">Início</th>
                  <th scope="col">Término</th>
                  <th scope="col">Situação</th>
                </tr>
              </thead>
              <tbody>
                {company?.sancoes?.map((sancao) => (
                  <tr key={sancao?.id}>
                    <td>
                      {sancao?.url ? (
                        <a href={sancao.url} target="_blank" rel="noreferrer">
                          {sancao?.category}
                        </a>
                      ) : (
                        sancao?.category
                      )}
                    </td>
                    <td>{sancao?.orgao_sancionador}</td>
                    <td>{formatDate(sancao?.penalty_start_date)}</td>
                    <td>{formatDate(sancao?.penalty_end_date)}</td>
                    <td>
                      <span
                        className={`badge ${
                          sancao?.available ? 'badge-danger' : 'badge-secondary'
                        }`}
                      >
                        {sancao?.available ? 'Vigente' : 'Encerrada'}
                      </span>
                    </td>
                  </tr>
                ))}
                {!company?.sancoes?.length && (
                  <tr>
                    <td colSpan={5} className="text-center border-0 pb-0">
                      <div className="alert alert-secondary m-0" role="alert">
                        <h4 className="alert-heading">Resultado não encontrado.</h4>
                        <p className="mb-0">
                          Não foram encontradas sanções para este CNPJ no Portal da Transparência.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </ul>
      </div>
    </>
  );
};

export default CompanyDetails;
